<template>
  <ul class="w-full">
    <li
      v-for="locale in locales"
      :key="locale.code"
      class="flex justify-between items-center py-2 border-b border-background"
      @click="setLocale(locale.code)"
    >
      <span class="text--md">{{ locale.language }}</span>

      <figure class="w-6 h-6">
        <img
loading="lazy"
          class="w-full"
          :src="`/img/flags/${locale.code}.jpg`"
          :alt="locale.code"
        />
      </figure>
    </li>
  </ul>
</template>

<script>
import {findLanguage, rememberLocale} from "@/services/localizationHelper";

export default {
  computed: {
    locales() {
      return this.$i18n.availableLocales.map((l) => {
        return { code: l, language: findLanguage(l) };
      });
    },
  },

  mounted() {
    this.$emit("input", this.selected);
  },

  methods: {
    setLocale(locale) {
      this.$i18n.locale = locale;
      rememberLocale(locale);
      this.$emit("close-menu");
    },
  },
};
</script>

<style lang="scss" scoped></style>
